import tw from 'twin.macro';
import {
  styled
} from 'styled-components';

export const SvgContainer = styled.div`
  ${tw`absolute`}
`;
